import template from './querychanges.html';
import controller from './querychanges.controller';
import './querychanges.styl';

let querychangesComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default querychangesComponent;



// WEBPACK FOOTER //
// ./client/app/common/reports/querychanges/querychanges.component.js